import { createElementObject, createPathComponent, extendContext } from './core';
import L from '@anlan/gs-map';
import type { GeoJSON as LeafletGeoJSONInstance, GeoJSONOptions } from '@anlan/gs-map';
import type { LeafletContextInterface, PathProps } from './core';
import type { LayerGroupProps } from './LayerGroup';
const LeafletGeoJSON = L.GeoJSON;

export interface GeoJSONProps extends GeoJSONOptions, LayerGroupProps, PathProps {
    data: object
}

export const GeoJSON = createPathComponent(function createGeoJSON({ data , ...options }: GeoJSONProps, ctx: LeafletContextInterface) {
    const geoJSON = new LeafletGeoJSON(data, options);
    return createElementObject(geoJSON, extendContext(ctx, {
        overlayContainer: geoJSON
    }));
}, function updateGeoJSON(layer: LeafletGeoJSONInstance, props: GeoJSONProps, prevProps: GeoJSONProps) {
    if (props.style !== prevProps.style) {
        if (props.style == null) {
            layer.resetStyle();
        } else {
            layer.setStyle(props.style);
        }
    }
});
